import { useEffect, useState } from "react";
import isClient from "../isClient";

// InitializeOnFirstClientRender was added to help avoid some layout shift in the true case.
// When the hook always started false there is a layout shift after this event listener is attached in true cases.
// The optional prop allows upgrading functionality without breaking previous implementation.

const useMedia = (query: string, initializeOnFirstClientRender = false) => {
  const init = () => {
    return initializeOnFirstClientRender
      ? isClient() && (window?.matchMedia(query).matches ?? false)
      : false;
  };
  const [matches, setMatches] = useState(init);

  useEffect(() => {
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);
    if (!initializeOnFirstClientRender) {
      listener();
    }
    media.addEventListener("change", listener);

    return () => media.removeEventListener("change", listener);
  }, [matches, query, initializeOnFirstClientRender]);

  return matches;
};

export default useMedia;
